import type { RescheduleScheduling, ScheduleTime } from '@src/core/buyerApiClient';

export function collectAvailableScheduleTimes(schedulings: RescheduleScheduling[]): ScheduleTime[] {
  return schedulings.reduce<ScheduleTime[]>((carry, scheduling) => {
    let minutesTimes = scheduling.availableScheduleTimes ?? [];

    minutesTimes = minutesTimes.filter((time) =>
      scheduling.scheduleAvailabilities.find((ast) => ast.minutes === time.minutes && ast.available),
    );

    return [...carry, ...minutesTimes];
  }, []);
}
